import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  ElementRef,
  forwardRef,
  SimpleChanges,
  AfterViewChecked,
  QueryList,
  ViewChildren
} from '@angular/core';

import {
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';

import * as Swiper from 'swiper/dist/js/swiper.js';

import { CheckoutService } from '../checkout.service';
import { NgForm, NgModelGroup, FormControl, ControlValueAccessor, Validator } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'jb-checkout-slider',
  templateUrl: './slider.component.html',
  styleUrls: [
    './slider.component.scss'
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => CheckoutSliderComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => CheckoutSliderComponent),
      multi: true
    }
  ]
})
export class CheckoutSliderComponent implements ControlValueAccessor, Validator, OnInit, AfterViewInit {
  private _value: string;

  private swiper;

  @Input()
  public designValues: string[];

  @Input()
  public initialize: boolean = true;

  @ViewChild('buttonsSwiper')
  public buttonsSwiper: ElementRef;
  
  @ViewChildren('buttonsSwiperQuery')
  public swiperQuery: QueryList<any>;

  @ViewChild('buttonsSwiperNext')
  public buttonsSwiperNext: ElementRef;

  @ViewChild('buttonsSwiperPrev')
  public buttonsSwiperPrev: ElementRef;

  @ViewChildren('video') 
  public videos;

  @Input()
  public form: NgForm;
  
  @Input()
  public group: NgModelGroup;

  protected propagateChange = (_: any) => {
    return;
  }

  constructor(
    private checkoutService: CheckoutService
  ) {
  }

  // this is the initial value set to the component
  public writeValue(value: any) {
    if (value) {
      this._value = value; 

      if (this.swiper) {
        this.swiper.slideToLoop(this.designValues.indexOf(this._value));
      }
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() {
    return;
  }

  // validates the form, returns null when valid else the validation object
  public validate(c: FormControl) {
    return null;
  }

  public ngOnInit() {
    if (!this.designValues) {
      this.designValues = this.checkoutService.designValues;
    }
  }

  public ngAfterViewInit() {
    if (this.initialize) {
      this.swiper = new Swiper(this.buttonsSwiper.nativeElement, {
        spaceBetween: 30,
        loop: true,
        observer: true,
        observeSlideChildren: true,
        navigation: {
          nextEl: this.buttonsSwiperNext.nativeElement,
          prevEl: this.buttonsSwiperPrev.nativeElement
        }
      });

      this.swiper.on('slideChange', () => {
        this._value = this.designValues[this.swiper.realIndex];
        let currentIndex = this.swiper.realIndex;
        let prevIndex = this.swiper.realIndex - 1;
        let nextIndex = this.swiper.realIndex + 1;
        if (!this.designValues.hasOwnProperty(prevIndex)) {
          prevIndex = this.designValues.length - 1;
        }
        if (!this.designValues.hasOwnProperty(nextIndex)) {
          nextIndex = 0;
        }

        let videosArray = this.videos.toArray();
        for (let i in videosArray) {
          if (videosArray[i].nativeElement.id === 'video-' + this.designValues[currentIndex]) {
            videosArray[i].nativeElement.play();
          } else {
            videosArray[i].nativeElement.pause();
          }
        }
        this.propagateChange(this._value);
      });
    }

    let videosArray = this.videos.toArray();
    for (let i in videosArray) {
      videosArray[i].nativeElement.muted = true;
      // videosArray[i].nativeElement.play();
    }

    this.swiperQuery.changes.subscribe((r) => {      
      if (typeof this.swiper !== 'undefined') {
        this.swiper.destroy();
      }
  
      this.swiper = new Swiper(this.buttonsSwiper.nativeElement, {
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: this.buttonsSwiperNext.nativeElement,
          prevEl: this.buttonsSwiperPrev.nativeElement
        }
      });

      this.swiper.on('slideChange', () => {
        this._value = this.designValues[this.swiper.realIndex];
        this.propagateChange(this._value);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/checkout/slider/slider.component.ts